import { OverlayRef } from '@angular/cdk/overlay';
import { EventEmitter } from '@angular/core';

export class DrawerPanelRef {
  disposed = false;

  constructor(
    private overlayRef: OverlayRef,
    private onHide?: EventEmitter<void>,
  ) {}

  close(): void {
    if (this.disposed) {
      return;
    }
    this.overlayRef.dispose();
    this.disposed = true;
    this.onHide?.emit();
  }
}
